<template lang="pug">
  .eventBtn-fixed
    .eventBtn-p
      .box(:class="{ translate : isTransform }" @click ="isTransform = !isTransform")
    .eventBtn-m
      .eventOther(@click="goToOrigin")
</template>

<script>
export default {
  data () {
    return {
      isTransform: false
    }
  },
  watch: {
    isTransform: function (newValue, oldValue) {
      if (oldValue === true && newValue === false) {
        this.goToOrigin()
      }
    }
  },
  methods: {
    goToOrigin () {
      window.location.href = window.location.origin + '/' + window.location.search
    }
  }
}
</script>

<style lang="scss">
@import '~breakpoint-sass/stylesheets/_breakpoint';
@import '../assets/styles/var';
.eventBtn-fixed {
  position: static;
  left: 0;
  bottom: 0;
  width: 100%;
}

.eventBtn-m {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 70px;
  @include breakpoint(orientation landscape){
    display: none;
  }
  &::after{
    content: "";
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.8);
    height: 10rem;
    display: block;
    position: absolute;
    top: calc(100% - 3.5rem);
    width: 100%;
    z-index: -10;
    transform: scale(1.3,1);
  }
  .eventOther{
    height: 55px;
    background: url('../assets/images/eventbtn_m.png') no-repeat center center;
    cursor: pointer;
  }
}

.eventBtn-p {
  display: none;
  width: 100px;
  height: 76px;
  position: fixed;
  right: 0;
  bottom: calc(35% - 38px);
  @include breakpoint(orientation landscape){
    display: block;
  }
  @include breakpoint(1024px) {
    bottom: calc(20% - 38px);
  }
  .box {
    transition: all 0.6s cubic-bezier(0.215, 0.61, 0.355, 1);
    transform:translateX(0%);
    width: 265px;
    height: 76px;
    color: #fff;
    cursor: pointer;
    background: url('../assets/images/eventbtn_p.png') no-repeat 0 0;
    &.translate {
      transform:translateX(-60%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/goback.vue